/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { EsitiOperazioneDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelServizioMensaRendicontazioneDTO } from '../model/models';
import { PagedModelServizioMensaRicaricaDTO } from '../model/models';
import { PagedModelServizioMensaStudenteDTO } from '../model/models';
import { PagedModelServizioMensaStudenteReportDTO } from '../model/models';
import { ServizioMensaAddPatchRicaricaForm } from '../model/models';
import { ServizioMensaDifformitaPastiDTO } from '../model/models';
import { ServizioMensaEsenzioneForm } from '../model/models';
import { ServizioMensaEventoAggiornamentoDTO } from '../model/models';
import { ServizioMensaEventoCalendarioDTO } from '../model/models';
import { ServizioMensaEventoCalendarioForm } from '../model/models';
import { ServizioMensaFratelloDTO } from '../model/models';
import { ServizioMensaGeneraDovutoForm } from '../model/models';
import { ServizioMensaMenuExtraForm } from '../model/models';
import { ServizioMensaMultiricaricaForm } from '../model/models';
import { ServizioMensaRendicontazioneDTO } from '../model/models';
import { ServizioMensaRicaricaDTO } from '../model/models';
import { ServizioMensaRicaricaDetailDTO } from '../model/models';
import { ServizioMensaRicaricheTotaliDTO } from '../model/models';
import { ServizioMensaSaldiInizialiForm } from '../model/models';
import { ServizioMensaSaldoInizialeForm } from '../model/models';
import { ServizioMensaSospensioneForm } from '../model/models';
import { ServizioMensaStudenteAggiornamentoDTO } from '../model/models';
import { ServizioMensaStudenteAnagraficaDTO } from '../model/models';
import { ServizioMensaStudenteDTO } from '../model/models';
import { ServizioMensaStudenteListFilter } from '../model/models';
import { ServizioMensaStudentePortafogliDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AddServizioMensaStudenteEventoCalendarioRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaEventoCalendarioForm: ServizioMensaEventoCalendarioForm;
}

export interface AggiornaStatoServizioMensaStudenteRicaricaRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface CancellaServizioMensaStudenteDovutoRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface CreateServizioMensaMultiricaricheRequestParams {
    gestioneMenseServizioId: string;
    servizioMensaMultiricaricaForm: ServizioMensaMultiricaricaForm;
}

export interface CreateServizioMensaStudenteRicaricaRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaAddPatchRicaricaForm: ServizioMensaAddPatchRicaricaForm;
}

export interface GeneraServizioMensaStudenteDovutoRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaGeneraDovutoForm: ServizioMensaGeneraDovutoForm;
}

export interface GetServizioMensaStudenteRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaStudenteFratelliRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaStudenteGenitoreAnagraficaRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaStudentePortafogliRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaStudenteRicaricaRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaStudenteRicaricheTotaliRequestParams {
    idStudente: string;
    anno: number;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaStudenteAggiornamentiRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaStudenteEventiCalendarioRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaStudenteEventoCalendarioAggiornamentiRequestParams {
    idStudente: string;
    idEvento: string;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaStudenteRendicontazioniRequestParams {
    idStudente: string;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaStudenteRicaricheRequestParams {
    idStudente: string;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaStudentiRequestParams {
    filter: ServizioMensaStudenteListFilter;
    pageable: Pageable;
    gestioneMenseServizioId: string;
}

export interface ListServizioMensaStudentiPerReportRequestParams {
    pageable: Pageable;
    gestioneMenseServizioId: string;
}

export interface PatchServizioMensaStudenteEsenzioneRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaEsenzioneForm: ServizioMensaEsenzioneForm;
}

export interface PatchServizioMensaStudenteRicaricaRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
    servizioMensaAddPatchRicaricaForm: ServizioMensaAddPatchRicaricaForm;
}

export interface PatchServizioMensaStudenteSospensioneRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaSospensioneForm: ServizioMensaSospensioneForm;
}

export interface RemoveServizioMensaStudenteEventoCalendarioRequestParams {
    idStudente: string;
    idEvento: string;
    gestioneMenseServizioId: string;
    forzaEvento?: boolean;
}

export interface RicalcolaServizioMensaPortafogliServizioRequestParams {
    gestioneMenseServizioId: string;
}

export interface RicalcolaServizioMensaStudentePortafogliRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
}

export interface RicalcolaServizioMensaStudenteRendicontazioneMensileRequestParams {
    idStudente: string;
    numeroMese: number;
    gestioneMenseServizioId: string;
    dataFinale?: string;
}

export interface ScaricaAvvisoServizioMensaOperatoreRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface ScaricaRicevutaServizioMensaOperatoreRequestParams {
    idStudente: string;
    idRicarica: string;
    gestioneMenseServizioId: string;
}

export interface SetServizioMensaStudenteMenuExtraRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaMenuExtraForm: ServizioMensaMenuExtraForm;
}

export interface SetServizioMensaStudenteSaldoInizialeRequestParams {
    idStudente: string;
    gestioneMenseServizioId: string;
    servizioMensaSaldoInizialeForm: ServizioMensaSaldoInizialeForm;
}

export interface SetServizioMensaStudentiSaldiInizialiRequestParams {
    gestioneMenseServizioId: string;
    servizioMensaSaldiInizialiForm: Array<ServizioMensaSaldiInizialiForm>;
}

export interface ToggleServizioMensaStudenteRendicontazioneDisabilitazioneRequestParams {
    idStudente: string;
    idRendicontazione: string;
    gestioneMenseServizioId: string;
}

export interface VerificaDifformitaPastiServizioMensaRequestParams {
    gestioneMenseServizioId: string;
}


export interface ServizioMensaStudentiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Aggiunge uno o più eventi calendario a uno studente.
     * Crea un evento ASSENZA/PASTA_IN_BIANCO per ogni giorno-mensa del range [data_inizio..data_fine] (esclude le chiusure settimanali). forza_evento bypassa il gate data-passata/oltre-cutoff (onorato per l\&#39;operatore). Su ASSENZA-passata ricalcola il portafogli (derivato). Audience OP_SCUOLA/ADMIN/SUPERADMIN e OP_COMUNE col permesso GESTIONE_CALENDARIO_MENSA. Studente di altro servizio → 404.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/evento-calendario
* @param requestParameters
     */
    addServizioMensaStudenteEventoCalendario(requestParameters: AddServizioMensaStudenteEventoCalendarioRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaEventoCalendarioDTO>>;

    /**
     * Aggiorna da PagoPA lo stato di una singola ricarica di uno studente.
     * Backoffice (ADMIN/SUPERADMIN/OP_COMUNE). Interroga PagoPA sulla sola posizione e ne riporta lo stato; su transizione a PAGATA ricalcola il portafogli e valuta la rimozione della sospensione. Nessuna accettazione con riserva. Ritorna il dettaglio con lo storico, che registra ogni verifica. Ricarica senza IUV o annullata → 400; errore del provider → 500.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}/aggiorna-stato
* @param requestParameters
     */
    aggiornaStatoServizioMensaStudenteRicarica(requestParameters: AggiornaStatoServizioMensaStudenteRicaricaRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDetailDTO>;

    /**
     * Cancella un dovuto PagoPA di uno studente.
     * Verbo POST (allineato al matcher legacy). Gate isRicaricaCancellabile; invoca PagoPA, stato CANCELLATA, scollega la rendicontazione. Ricarica di altro studente → 404.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/cancella-pagamento
* @param requestParameters
     */
    cancellaServizioMensaStudenteDovuto(requestParameters: CancellaServizioMensaStudenteDovutoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDTO>;

    /**
     * Crea più ricariche in bulk (multiricarica operatore).
     * Itera la creazione singola per ciascuna riga; ogni studente è scopato al servizio header (anti-IDOR). Studente di altro servizio nella lista → 404 sull\&#39;intera richiesta. NON esposto al cittadino.
     * @endpoint post /api/v1/servizi/mensa/studenti/ricariche
* @param requestParameters
     */
    createServizioMensaMultiricariche(requestParameters: CreateServizioMensaMultiricaricheRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaRicaricaDTO>>;

    /**
     * Crea una ricarica per uno studente (PagoPA o manuale).
     * Gate sul tipoPagamento del servizio: ramo PagoPA crea il dovuto (IN_ATTESA_PAGAMENTO); ramo MANUALE (ADMIN/OP_COMUNE) inserisce una PAGATA + ricalcolo multi-anno. Studente esente → errore; valore &lt; 0 → errore; valore &gt; importo massimo (servizio) → errore.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/ricarica
* @param requestParameters
     */
    createServizioMensaStudenteRicarica(requestParameters: CreateServizioMensaStudenteRicaricaRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDTO>;

    /**
     * Genera un dovuto PagoPA da una rendicontazione.
     * Solo servizi PAGO_PA_RENDICONTAZIONE*; risolve la rendicontazione (ownership), richiede importo negativo, niente dovuto valido esistente, crea ricarica + dovuto e la collega alla rendicontazione. Studente di altro servizio → 404.
     * @endpoint post /api/v1/servizi/mensa/studenti/{id_studente}/genera-dovuto
* @param requestParameters
     */
    generaServizioMensaStudenteDovuto(requestParameters: GeneraServizioMensaStudenteDovutoRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDTO>;

    /**
     * Dettaglio di uno studente del servizio mensa (studente + stato).
     * Ritorna lo studente del servizio con identità/scolastico/dieta dal reader e i campi operativi mensa dalle colonne native. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}
* @param requestParameters
     */
    getServizioMensaStudente(requestParameters: GetServizioMensaStudenteRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaStudenteDTO>;

    /**
     * Fratelli di uno studente del servizio mensa.
     * Ritorna gli altri studenti dello stesso genitore (richiedente) nel servizio, non sospesi, escluso lo studente stesso. Studente di altro servizio → 404. Per un OP_SCUOLA la coorte NON e\&#39; ridotta (serve al conteggio dello sconto multifiglio) ma i fratelli iscritti a scuole non assegnate sono restituiti in forma ridotta: visibile&#x3D;false e nessun dato identificativo.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/fratelli
* @param requestParameters
     */
    getServizioMensaStudenteFratelli(requestParameters: GetServizioMensaStudenteFratelliRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaFratelloDTO>>;

    /**
     * Anagrafica del genitore di uno studente del servizio mensa.
     * Ritorna l\&#39;anagrafica del genitore (richiedente) dello studente, letta via FK origine + reader. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/genitore-anagrafica
* @param requestParameters
     */
    getServizioMensaStudenteGenitoreAnagrafica(requestParameters: GetServizioMensaStudenteGenitoreAnagraficaRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaStudenteAnagraficaDTO>;

    /**
     * Portafogli di uno studente del servizio mensa.
     * Ritorna il portafogli (residuo, pasti residui, costo pasto/contributo, saldo iniziale, pasti usufruiti) dello studente. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/portafogli
* @param requestParameters
     */
    getServizioMensaStudentePortafogli(requestParameters: GetServizioMensaStudentePortafogliRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaStudentePortafogliDTO>;

    /**
     * Dettaglio di una ricarica di uno studente (con aggiornamenti).
     * Ritorna la ricarica con la lista ordinata degli aggiornamenti (audit). Anti-IDOR cross-studente: ricarica di altro studente → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}
* @param requestParameters
     */
    getServizioMensaStudenteRicarica(requestParameters: GetServizioMensaStudenteRicaricaRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDetailDTO>;

    /**
     * Totale dei pagamenti di uno studente per anno solare.
     * Somma del valore delle ricariche PAGATA con min(data, dataPagamento) nell\&#39;anno richiesto (D-18.17). Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/totali
* @param requestParameters
     */
    getServizioMensaStudenteRicaricheTotali(requestParameters: GetServizioMensaStudenteRicaricheTotaliRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricheTotaliDTO>;

    /**
     * Storico degli aggiornamenti di stato di uno studente.
     * Ritorna lo storico ordinato degli aggiornamenti di stato dello studente (attore tipizzato, commento, lista operazioni). Sola lettura, backoffice stretto (ADMIN/SUPERADMIN/OP_COMUNE — OP_SCUOLA/OP_CENTRO_COTTURA esclusi). Studente di altro servizio → 404; nessun aggiornamento → 200 [].
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/aggiornamenti
* @param requestParameters
     */
    listServizioMensaStudenteAggiornamenti(requestParameters: ListServizioMensaStudenteAggiornamentiRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaStudenteAggiornamentoDTO>>;

    /**
     * Lista degli eventi calendario personali di uno studente.
     * Eventi personali dello studente ordinati per data, incluse le CANCELLATE (audience operatore). Niente chiusure scolastiche (D-18.24). Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/evento-calendario
* @param requestParameters
     */
    listServizioMensaStudenteEventiCalendario(requestParameters: ListServizioMensaStudenteEventiCalendarioRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaEventoCalendarioDTO>>;

    /**
     * Storico audit di un evento calendario di uno studente.
     * Ritorna lo storico ordinato degli aggiornamenti audit del singolo evento calendario (attore tipizzato, operazione). Solo operatore (audience servizio piena); NON esposto al cittadino. Anti-IDOR chain evento→studente: evento di altro studente → 404. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/evento-calendario/{id_evento}/aggiornamenti
* @param requestParameters
     */
    listServizioMensaStudenteEventoCalendarioAggiornamenti(requestParameters: ListServizioMensaStudenteEventoCalendarioAggiornamentiRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaEventoAggiornamentoDTO>>;

    /**
     * Lista paginata delle rendicontazioni mensili di uno studente.
     * Ritorna le rendicontazioni dello studente, incluse le disabilitate (audience operatore). Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/rendicontazioni
* @param requestParameters
     */
    listServizioMensaStudenteRendicontazioni(requestParameters: ListServizioMensaStudenteRendicontazioniRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaRendicontazioneDTO>;

    /**
     * Lista paginata delle ricariche di uno studente.
     * Ritorna le ricariche dello studente (Page, ordine dataPagamento DESC, data DESC). DTO leggero senza aggiornamenti. Studente di altro servizio → 404.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche
* @param requestParameters
     */
    listServizioMensaStudenteRicariche(requestParameters: ListServizioMensaStudenteRicaricheRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaRicaricaDTO>;

    /**
     * Lista filtrata degli studenti del servizio mensa.
     * Ritorna gli studenti del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id, filtrabili per nominativo, codice pratica, scuola/plesso, classe, sezione, pasti residui (range), esente, sospeso. Audience operatore.
     * @endpoint post /api/v1/servizi/mensa/studenti
* @param requestParameters
     */
    listServizioMensaStudenti(requestParameters: ListServizioMensaStudentiRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaStudenteDTO>;

    /**
     * Lista degli studenti del servizio mensa per report.
     * Ritorna gli studenti del servizio con i relativi portafogli, per il report.
     * @endpoint get /api/v1/servizi/mensa/studenti/report
* @param requestParameters
     */
    listServizioMensaStudentiPerReport(requestParameters: ListServizioMensaStudentiPerReportRequestParams, extraHttpRequestParams?: any): Observable<PagedModelServizioMensaStudenteReportDTO>;

    /**
     * Toggle esenzione di uno studente con ricalcolo multi-anno.
     * Set isEsente/motivoEsenzione con tracking delta; se ricalcola_portafogli&#x3D;true e il valore di esenzione cambia, delega il ricalcolo al motore multi-anno. Studente di altro servizio → 404.
     * @endpoint patch /api/v1/servizi/mensa/studenti/{id_studente}/esenzione
* @param requestParameters
     */
    patchServizioMensaStudenteEsenzione(requestParameters: PatchServizioMensaStudenteEsenzioneRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaStudenteDTO>;

    /**
     * Modifica una ricarica manuale di uno studente.
     * Solo ricariche di pagamento manuale; aggiorna bollettino/dataPagamento/valore/note (diff) + audit; su delta valore → ricalcolo multi-anno. Ricarica di altro studente → 404.
     * @endpoint patch /api/v1/servizi/mensa/studenti/{id_studente}/ricarica/{id_ricarica}
* @param requestParameters
     */
    patchServizioMensaStudenteRicarica(requestParameters: PatchServizioMensaStudenteRicaricaRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRicaricaDTO>;

    /**
     * Toggle sospensione di uno studente.
     * Idempotente (nessun cambio se già nello stato richiesto); delega al chokepoint pagamenti. Studente di altro servizio → 404.
     * @endpoint patch /api/v1/servizi/mensa/studenti/{id_studente}/sospensione
* @param requestParameters
     */
    patchServizioMensaStudenteSospensione(requestParameters: PatchServizioMensaStudenteSospensioneRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaStudenteDTO>;

    /**
     * Rimuove (cancella logicamente) un evento calendario di uno studente.
     * Imposta stato&#x3D;CANCELLATO + audit; forzaEvento bypassa il gate data-passata/oltre-cutoff. Su ASSENZA-passata ricalcola il portafogli (derivato). Audience OP_SCUOLA/ADMIN/SUPERADMIN e OP_COMUNE col permesso GESTIONE_CALENDARIO_MENSA. Evento di altro studente → 404.
     * @endpoint delete /api/v1/servizi/mensa/studenti/{id_studente}/evento-calendario/{id_evento}
* @param requestParameters
     */
    removeServizioMensaStudenteEventoCalendario(requestParameters: RemoveServizioMensaStudenteEventoCalendarioRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaEventoCalendarioDTO>;

    /**
     * Ricalcolo del portafogli di tutti gli studenti del servizio.
     * Ridefinizione per-servizio del legacy ricalcola-portafogli-comune: scope header-tenant. Ritorna gli eventuali errori per-studente.
     * @endpoint put /api/v1/servizi/mensa/studenti/ricalcola-portafogli-servizio
* @param requestParameters
     */
    ricalcolaServizioMensaPortafogliServizio(requestParameters: RicalcolaServizioMensaPortafogliServizioRequestParams, extraHttpRequestParams?: any): Observable<EsitiOperazioneDTO>;

    /**
     * Ricalcolo del portafogli di un singolo studente.
     * Delega al motore multi-anno; audit per-studente. Studente di altro servizio → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/ricalcola-portafogli
* @param requestParameters
     */
    ricalcolaServizioMensaStudentePortafogli(requestParameters: RicalcolaServizioMensaStudentePortafogliRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaStudenteDTO>;

    /**
     * Ricalcolo della rendicontazione mensile di uno studente.
     * Delega al motore multi-anno. numero_mese in [1..12]; dataFinale opzionale (YYYY-MM-DD). Rendicontazione disabilitata → skip; dovuto già generato → errore diagnostico. Studente di altro servizio → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/ricalcola-rendicontazione-mensile/{numero_mese}
* @param requestParameters
     */
    ricalcolaServizioMensaStudenteRendicontazioneMensile(requestParameters: RicalcolaServizioMensaStudenteRendicontazioneMensileRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Scarica l\&#39;avviso di pagamento (PDF) di una ricarica di uno studente.
     * Lettura (audience servizio piena, catch-all studenti). Ritorna il PDF dell\&#39;avviso PagoPA come allegato (application/pdf, Content-Disposition: attachment). Anti-IDOR studente (header-tenant) + ricarica (cross-studente). Avviso senza numeroAvviso → 400.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}/avviso
* @param requestParameters
     */
    scaricaAvvisoServizioMensaOperatore(requestParameters: ScaricaAvvisoServizioMensaOperatoreRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Scarica la ricevuta di pagamento (PDF) di una ricarica di uno studente.
     * Lettura (audience servizio piena, catch-all studenti). Ritorna il PDF della ricevuta PagoPA come allegato (application/pdf, Content-Disposition: attachment). Anti-IDOR studente (header-tenant) + ricarica (cross-studente). Ricevuta senza IUV → 400.
     * @endpoint get /api/v1/servizi/mensa/studenti/{id_studente}/ricariche/{id_ricarica}/ricevuta
* @param requestParameters
     */
    scaricaRicevutaServizioMensaOperatore(requestParameters: ScaricaRicevutaServizioMensaOperatoreRequestParams, extraHttpRequestParams?: any): Observable<Blob>;

    /**
     * Associa/rimuove il menu extra di uno studente.
     * Audience OP_SCUOLA e OP_COMUNE (+ ADMIN/SUPERADMIN), NON OP_CENTRO_COTTURA. Identificativo valorizzato → menu EXTRA del servizio; ORDINARIO non associabile; null/vuoto → azzera. Studente di altro servizio → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/menu-extra
* @param requestParameters
     */
    setServizioMensaStudenteMenuExtra(requestParameters: SetServizioMensaStudenteMenuExtraRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaStudenteDTO>;

    /**
     * Set/edit del saldo iniziale del portafogli di uno studente.
     * Aggiusta il residuo in modo incrementale (delta sul saldo iniziale precedente) e imposta il nuovo saldo iniziale. Studente di altro servizio → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/saldo-iniziale
* @param requestParameters
     */
    setServizioMensaStudenteSaldoIniziale(requestParameters: SetServizioMensaStudenteSaldoInizialeRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaStudenteDTO>;

    /**
     * Set/edit bulk del saldo iniziale per più studenti.
     * Stessa formula del set singolo, per riga, con scope per-servizio (studenti di altri servizi ignorati). Ritorna i messaggi degli studenti saltati.
     * @endpoint put /api/v1/servizi/mensa/studenti/saldi-iniziali
* @param requestParameters
     */
    setServizioMensaStudentiSaldiIniziali(requestParameters: SetServizioMensaStudentiSaldiInizialiRequestParams, extraHttpRequestParams?: any): Observable<EsitiOperazioneDTO>;

    /**
     * Toggle disabilitazione di una rendicontazione di uno studente.
     * ADMIN/SUPERADMIN-only (NON OP_COMUNE, asimmetria legacy). Inverte disabilitata: la disabilitazione è rifiutata se la ricarica collegata è in stato diverso da ERRORE/CANCELLATA (dovuto attivo); la riabilitazione è sempre consentita, nessun ricalcolo. Rendicontazione di altro studente → 404.
     * @endpoint put /api/v1/servizi/mensa/studenti/{id_studente}/rendicontazione/{id_rendicontazione}/toggle-disabilitazione
* @param requestParameters
     */
    toggleServizioMensaStudenteRendicontazioneDisabilitazione(requestParameters: ToggleServizioMensaStudenteRendicontazioneDisabilitazioneRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaRendicontazioneDTO>;

    /**
     * Verifica difformità pasti del servizio mensa.
     * Confronta i pasti calcolati dal calendario reference con quelli salvati sul portafogli, per gli studenti del servizio. Diagnostico ADMIN/SUPERADMIN.
     * @endpoint get /api/v1/servizi/mensa/studenti/verifica-difformita-pasti
* @param requestParameters
     */
    verificaDifformitaPastiServizioMensa(requestParameters: VerificaDifformitaPastiServizioMensaRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaDifformitaPastiDTO>;

}
